import { Card, CardContent, CircularProgress, Grid } from '@mui/material'
import { type AssetByIdState } from '../redux/assetByIdSlice'
import AssetSummary from './AssetSummary'
import React from 'react'
import ActiveIssuesTable from './ActiveIssues'
import { type AlarmByIdState } from '../redux/alarmsByIdSlice'
import AuthError from '../../../components/ErrorComponents/AuthError'

const Overview = (props: { fetchAlarmsById: () => void, assetData: AssetByIdState, OverviewStrings: any, alarmsById: AlarmByIdState }): JSX.Element => {
  const handleRetry = (): void => {
    props.fetchAlarmsById()
  }

  function AlarmTable (): any {
    if (props.alarmsById.isLoading) {
      return (
      <div className='deviceDetailsProgress'><CircularProgress data-testid='deviceDetailsProgress' size={'5rem'} /></div>)
    } else if (props.alarmsById.httpStatus === 401) {
      return (
              <div className='authError'><AuthError errorMessage="Unauthorized"/></div>
      )
    } else if (props.alarmsById.httpStatus === 403) {
      return (
          <div className='authError'><AuthError errorMessage="accessForbidden"/></div>
      )
    } else if (props.alarmsById.alarmData !== null && props.alarmsById.alarmData !== undefined && props.alarmsById.httpStatus === 200) {
      return (
      <ActiveIssuesTable alarmsById={props.alarmsById} OverviewStrings={props.OverviewStrings} />)
    } else if ((props.alarmsById.alarmData !== null && props.alarmsById.alarmData !== undefined && props.alarmsById.alarmData.length === 0)) {
      return (
        <div className='authError'><AuthError errorMessage="NoDataPresent"/></div>
      )
    } else if (((props.alarmsById.errorMessage?.includes('not found')) === true)) {
      return (
        <div className='authError'><AuthError errorMessage="NoDataPresent"/></div>
      )
    } else {
      return (
        <div className='authError'><AuthError retry={handleRetry} errorMessage="cannotFetch"/></div>
      )
    }
  }

  function handleAssetSummary (): any {
    if (props.assetData.isLoading) {
      return (
      <div className='deviceDetailsProgress'><CircularProgress data-testid='deviceDetailsProgress' size={'5rem'} /></div>)
    } else if (props.assetData.httpStatus === 401) {
      return (
              <div className='authError'><AuthError errorMessage="Unauthorized"/></div>
      )
    } else if (props.assetData.httpStatus === 403) {
      return (
          <div className='authError'><AuthError errorMessage="accessForbidden"/></div>
      )
    } else if (props.assetData.assetData !== null && props.assetData.assetData !== undefined && props.assetData.httpStatus === 200) {
      return (
        <AssetSummary assetData={props.assetData} OverviewStrings={props.OverviewStrings} />)
    } else {
      return (
        <div className='authError'><AuthError retry={handleRetry} errorMessage="cannotFetch"/></div>
      )
    }
  }

  return (
    <div>
        <Grid item xs={12} sm={12} className='active-issues'>
          <h4>{props.OverviewStrings.ACTIVE_ISSUES}({props.alarmsById.alarmData?.length})</h4>
          <Card sx={{ borderRadius: '10px', backgroundColor: '#353535' }}>
            <CardContent sx={{ padding: '0' }}>
            {AlarmTable()}
            </CardContent>
          </Card>
        </Grid>
        <br />
        <Grid item xs={12} sm={12}>
          <Card sx={{ borderRadius: '10px', backgroundColor: '#272727', color: '#F0F0F0 !important', padding: '25px' }}>
            <h4>{props.OverviewStrings.ASSET_SUMMARY}</h4>
            <CardContent>
              {handleAssetSummary()}
            </CardContent>
          </Card>
        </Grid>
    </div>
  )
}

export default Overview
